"use client";

import { usePathname } from "next/navigation";
import Header from "./Header";
import HeaderMain from "./HeaderMain";

export default function HeaderSelector() {
  const pathname = usePathname();
  
  // Homepage uses HeaderMain, all other pages use Header
  if (pathname === "/") {
    return <HeaderMain />;
  }
  
  return <Header />;
}
